// import React from "react";


// const ProductCard = () => {
//   return (
//     <div className="bg-white rounded-lg shadow-sm p-3">
//       <img
//         src="https://images.unsplash.com/photo-1520975916090-3105956dac38"
//         alt="product"
//         className="w-full h-60 object-cover rounded"
//       />

//       <div className="mt-2 text-sm">
//         <p className="font-semibold">JAAR FASHION</p>
//         <p className="text-gray-600">Men Loose Fit Mid Rise...</p>

//         <div className="flex items-center gap-1 mt-1 text-xs">
//           ⭐ 5.0 <span className="text-blue-600">(789)</span>
//         </div>

//         <div className="flex items-center gap-2 mt-1">
//           <span className="font-semibold">₹6999</span>
//           <span className="line-through text-gray-400 text-sm">₹8999</span>
//           <span className="text-green-600 text-xs">22% off</span>
//         </div>

//         <div className="flex gap-2 mt-3">
//           <button className="bg-blue-600 text-white text-sm px-3 py-1 rounded w-full">
//             Buy Now
//           </button>
//           <button className="border px-3 py-1 rounded text-sm">
//             🛒
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


// import React from "react";
// import { useNavigate } from "react-router-dom";

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();

//   return (
//     <div
//      onClick={() => navigate(`/view-one-product/${product._id}`)}
//      className="bg-white rounded-lg shadow-sm p-3 hover:shadow-md transition">

//       {/* IMAGE */}
//       <img
//         src={product.previewImage || "https://via.placeholder.com/300"}
//         alt={product.productName}
//         className="w-full h-60 object-cover rounded"
//       />

//       <div className="mt-2 text-sm">

//         {/* BRAND */}
//         <p className="font-semibold uppercase">
//           {product.brand || "Brand"}
//         </p>

//         {/* PRODUCT NAME */}
//         <p className="text-gray-600 line-clamp-2">
//           {product.productName}
//         </p>

//         {/* VARIANT INFO */}
//         <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
//           {product.variantCount} Variants
//         </div>

//         {/* PRICE – STATIC FOR NOW */}
//         <div className="flex items-center gap-2 mt-1">
//           <span className="font-semibold">₹999</span>
//           <span className="line-through text-gray-400 text-sm">
//             ₹1299
//           </span>
//           <span className="text-green-600 text-xs">
//             23% off
//           </span>
//         </div>

//         {/* ACTION BUTTONS */}
//         <div className="flex gap-2 mt-3">
//           {/* <button className="bg-blue-600 text-white text-sm px-3 py-1 rounded w-full">
//             Buy Now
//           </button>
//           <button className="border px-3 py-1 rounded text-sm">
//             🛒
//           </button> */}
//           <button
//           onClick={(e) => {
//             e.stopPropagation();
//             console.log("Buy Now clicked");
//           }}
//           className="bg-blue-600 text-white text-sm px-3 py-1 rounded w-full"
//         >
//           Buy Now
//         </button>

//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             console.log("Add to cart clicked");
//           }}
//           className="border px-3 py-1 rounded text-sm"
//         >
//           🛒
//         </button>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


// import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();

//   /* ---------------- PRICE CALCULATION ---------------- */
//   const priceInfo = useMemo(() => {
//     const prices = [];
//     const mrps = [];

//     product?.variants?.forEach((v) => {
//       v?.sizes?.forEach((s) => {
//         if (s.price != null) prices.push(Number(s.price));
//         if (s.mrp != null) mrps.push(Number(s.mrp));
//       });
//     });

//     if (!prices.length) return null;

//     const minPrice = Math.min(...prices);
//     const maxPrice = Math.max(...prices);
//     const maxMRP = mrps.length ? Math.max(...mrps) : null;

//     const discount =
//       maxMRP && maxMRP > minPrice
//         ? Math.round(((maxMRP - minPrice) / maxMRP) * 100)
//         : null;

//     return { minPrice, maxPrice, maxMRP, discount };
//   }, [product]);

//   return (
//     <div
//       onClick={() => navigate(`/view-one-product/${product._id}`)}
//       className="bg-white rounded-lg shadow-sm p-3 hover:shadow-md transition cursor-pointer"
//     >
//       {/* IMAGE */}
//       <img
//         src={product.previewImage || "https://via.placeholder.com/300"}
//         alt={product.productName}
//         className="w-full h-60 object-cover rounded"
//       />

//       <div className="mt-2 text-sm">
//         {/* BRAND */}
//         <p className="font-semibold uppercase">
//           {product.brand || "Brand"}
//         </p>

//         {/* PRODUCT NAME */}
//         <p className="text-gray-600 line-clamp-2">
//           {product.productName}
//         </p>

//         {/* VARIANT INFO */}
//         <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
//           {product.variantCount} Variants
//         </div>

//         {/* PRICE – DYNAMIC */}
//         {priceInfo && (
//           <div className="flex items-center gap-2 mt-1">
//             <span className="font-semibold">
//               {priceInfo.minPrice === priceInfo.maxPrice
//                 ? `₹${priceInfo.minPrice}`
//                 : `₹${priceInfo.minPrice} – ₹${priceInfo.maxPrice}`}
//             </span>

//             {priceInfo.maxMRP && (
//               <span className="line-through text-gray-400 text-sm">
//                 ₹{priceInfo.maxMRP}
//               </span>
//             )}

//             {priceInfo.discount && (
//               <span className="text-green-600 text-xs">
//                 {priceInfo.discount}% off
//               </span>
//             )}
//           </div>
//         )}

//         {/* ACTION BUTTONS */}
//         <div className="flex gap-2 mt-3">
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               console.log("Buy Now clicked");
//             }}
//             className="bg-blue-600 text-white text-sm px-3 py-1 rounded w-full"
//           >
//             Buy Now
//           </button>

//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               console.log("Add to cart clicked");
//             }}
//             className="border px-3 py-1 rounded text-sm"
//           >
//             🛒
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


// import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();

//   /* ---------------- PRICE CALCULATION ---------------- */
//   const priceInfo = useMemo(() => {
//     const prices = [];
//     const mrps = [];

//     product?.variants?.forEach((v) => {
//       v?.sizes?.forEach((s) => {
//         if (s.price != null) prices.push(Number(s.price));
//         if (s.mrp != null) mrps.push(Number(s.mrp));
//       });
//     });

//     if (!prices.length) return null;

//     const minPrice = Math.min(...prices);
//     const maxPrice = Math.max(...prices);
//     const maxMRP = mrps.length ? Math.max(...mrps) : null;

//     const discount =
//       maxMRP && maxMRP > minPrice
//         ? Math.round(((maxMRP - minPrice) / maxMRP) * 100)
//         : null;

//     return { minPrice, maxPrice, maxMRP, discount };
//   }, [product]);

//   return (
//     <div
//       onClick={() => navigate(`/view-one-product/${product._id}`)}
//       className="bg-white rounded-lg shadow-sm hover:shadow-md transition cursor-pointer"
//     >
//       {/* IMAGE (RESPONSIVE – FIXED) */}
//       <div className="aspect-[4/3] w-full bg-gray-100 rounded-t-lg overflow-hidden">
//         <img
//           src={product.previewImage || "https://via.placeholder.com/300"}
//           alt={product.productName}
//           className="w-full h-full object-contain"
//         />
//       </div>

//       {/* CONTENT */}
//       <div className="p-3 text-sm">
//         {/* BRAND */}
//         <p className="font-semibold uppercase">
//           {product.brand || "Brand"}
//         </p>

//         {/* PRODUCT NAME */}
//         <p className="text-gray-600 line-clamp-2">
//           {product.productName}
//         </p>

//         {/* VARIANT INFO */}
//         <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
//           {product.variantCount} Variants
//         </div>

//         {/* PRICE */}
//         {priceInfo && (
//           <div className="flex items-center gap-2 mt-1">
//             <span className="font-semibold">
//               {priceInfo.minPrice === priceInfo.maxPrice
//                 ? `₹${priceInfo.minPrice}`
//                 : `₹${priceInfo.minPrice} – ₹${priceInfo.maxPrice}`}
//             </span>

//             {priceInfo.maxMRP && (
//               <span className="line-through text-gray-400 text-sm">
//                 ₹{priceInfo.maxMRP}
//               </span>
//             )}

//             {priceInfo.discount && (
//               <span className="text-green-600 text-xs">
//                 {priceInfo.discount}% off
//               </span>
//             )}
//           </div>
//         )}

//         {/* ACTION BUTTONS */}
//         <div className="flex gap-2 mt-3">
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               console.log("Buy Now clicked");
//             }}
//             className="bg-blue-600 text-white text-sm px-3 py-1 rounded w-full"
//           >
//             Buy Now
//           </button>

//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               console.log("Add to cart clicked");
//             }}
//             className="border px-3 py-1 rounded text-sm"
//           >
//             🛒
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;

// import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { ShoppingCart } from "lucide-react";
// import { useCart } from "../../context/CartContext";
// import toast from "react-hot-toast";

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();
//   const { addToCart } = useCart(); // 🔥 your existing cart logic

//   /* ---------------- PRICE CALCULATION ---------------- */
//   const priceInfo = useMemo(() => {
//     const prices = [];
//     const mrps = [];

//     product?.variants?.forEach((v) => {
//       v?.sizes?.forEach((s) => {
//         if (s.price != null) prices.push(Number(s.price));
//         if (s.mrp != null) mrps.push(Number(s.mrp));
//       });
//     });

//     if (!prices.length) return null;

//     const minPrice = Math.min(...prices);
//     const maxPrice = Math.max(...prices);
//     const maxMRP = mrps.length ? Math.max(...mrps) : null;

//     const discount =
//       maxMRP && maxMRP > minPrice
//         ? Math.round(((maxMRP - minPrice) / maxMRP) * 100)
//         : null;

//     return { minPrice, maxPrice, maxMRP, discount };
//   }, [product]);

//   /* ---------------- HANDLERS ---------------- */

//   const handleAddToCart = async (e) => {
//     e.stopPropagation();

//     try {
//       await addToCart(product, 1); // quantity = 1
//       toast.success("Added to cart");
//     } catch (err) {
//       toast.error("Failed to add to cart");
//     }
//   };

//   const handleBuyNow = async (e) => {
//     e.stopPropagation();

//     try {
//       await addToCart(product, 1, { replaceCart: true }); 
//       // 👆 optional: clear existing cart & add only this product

//       navigate("/checkout"); // 🔥 DIRECT CHECKOUT
//     } catch (err) {
//       toast.error("Unable to proceed to checkout");
//     }
//   };

//   return (
//     <div
//       onClick={() => navigate(`/view-one-product/${product._id}`)}
//       className="
//         bg-white rounded-xl border hover:shadow-lg transition
//         cursor-pointer flex flex-col
//       "
//     >
//       {/* IMAGE */}
//       <div className="aspect-[4/3] w-full bg-gray-100 rounded-t-xl overflow-hidden">
//         <img
//           src={product.previewImage || "https://via.placeholder.com/300"}
//           alt={product.productName}
//           className="w-full h-full object-contain transition-transform hover:scale-105"
//         />
//       </div>

//       {/* CONTENT */}
//       <div className="p-3 flex flex-col flex-1">
//         {/* BRAND */}
//         <p className="font-semibold uppercase text-xs text-gray-700">
//           {product.brand || "Brand"}
//         </p>

//         {/* PRODUCT NAME */}
//         <p className="text-gray-600 text-sm line-clamp-2 mt-1 flex-1">
//           {product.productName}
//         </p>

//         {/* PRICE */}
//         {priceInfo && (
//           <div className="mt-2 flex items-center gap-2 flex-wrap">
//             <span className="font-semibold text-sm">
//               {priceInfo.minPrice === priceInfo.maxPrice
//                 ? `₹${priceInfo.minPrice}`
//                 : `₹${priceInfo.minPrice} – ₹${priceInfo.maxPrice}`}
//             </span>

//             {priceInfo.maxMRP && (
//               <span className="line-through text-gray-400 text-xs">
//                 ₹{priceInfo.maxMRP}
//               </span>
//             )}

//             {priceInfo.discount && (
//               <span className="text-green-600 text-xs font-medium">
//                 {priceInfo.discount}% OFF
//               </span>
//             )}
//           </div>
//         )}

//         {/* ACTION BUTTONS */}
//         <div className="mt-3 flex gap-2">
//           {/* BUY NOW */}
//           <button
//             onClick={handleBuyNow}
//             className="
//               flex items-center justify-center gap-1
//               bg-blue-600 hover:bg-blue-700
//               text-white text-sm font-medium
//               px-3 py-2 rounded-lg w-full
//               transition
//             "
//           >
//             {/* <Zap size={16} /> */}
//             Buy Now
//           </button>

//           {/* ADD TO CART */}
//           <button
//             onClick={handleAddToCart}
//             className="
//               border border-gray-300 hover:border-blue-600
//               text-gray-700 hover:text-blue-600
//               px-3 py-2 rounded-lg
//               transition flex items-center justify-center
//             "
//           >
//             <ShoppingCart size={18} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { toast } from "react-hot-toast";

import { addToCart } from "../../helpers/cartHelper";
import { normalizeCartItem } from "../../helpers/cartNormalizer";
import navigateToCheckout from "../../helpers/navigateToCheckout";
import { useCart } from "../../context/CartContext";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { refreshCart } = useCart();
  const token = localStorage.getItem("token");

  /* ---------------- PRICE CALCULATION ---------------- */
  const priceInfo = useMemo(() => {
    const prices = [];
    const mrps = [];

    product?.variants?.forEach((v) => {
      v?.sizes?.forEach((s) => {
        if (s.price != null) prices.push(Number(s.price));
        if (s.mrp != null) mrps.push(Number(s.mrp));
      });
    });

    if (!prices.length) return null;

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const maxMRP = mrps.length ? Math.max(...mrps) : null;

    const discount =
      maxMRP && maxMRP > minPrice
        ? Math.round(((maxMRP - minPrice) / maxMRP) * 100)
        : null;

    return { minPrice, maxPrice, maxMRP, discount };
  }, [product]);

  /* ---------------- DEFAULT SELECTION ---------------- */
  const defaultVariant = product?.variants?.[0];
  const defaultSize = defaultVariant?.sizes?.[0];

  /* ---------------- ADD TO CART ---------------- */
  const handleAddToCart = async (e) => {
    e.stopPropagation();

    if (!defaultVariant || !defaultSize) {
      toast.error("Product options not available");
      return;
    }

    try {
      const res = await addToCart({
        productId: product._id,
        variantId: defaultVariant._id,
        sizeId: defaultSize._id,
        quantity: 1,
        token,
      });

      toast.success(
        res.mode === "guest"
          ? "Added to cart (Guest)"
          : "Added to cart"
      );

      refreshCart();
    } catch (err) {
      toast.error("Failed to add to cart");
      console.error(err);
    }
  };

  /* ---------------- BUY NOW (DIRECT CHECKOUT) ---------------- */
  // const handleBuyNow = (e) => {
  //   e.stopPropagation();

  //   if (!defaultVariant || !defaultSize) {
  //     toast.error("Product options not available");
  //     return;
  //   }

  //   // 🔁 SAME STRUCTURE AS PDP
  //   const rawItem = {
  //     product: {
  //       _id: product._id,
  //       name: product.productName,
  //     },
  //     variant: {
  //       _id: defaultVariant._id,
  //       colorCode: defaultVariant.colorCode,
  //       images: defaultVariant.images,
  //     },
  //     size: {
  //       _id: defaultSize._id,
  //       size: defaultSize.size || "",
  //       price: defaultSize.price,
  //       mrp: defaultSize.mrp,
  //       stock: defaultSize.stock,
  //     },
  //     quantity: 1,
  //   };

  //   const normalizedItem = normalizeCartItem(rawItem);

  //   navigateToCheckout(
  //     navigate,
  //     [normalizedItem],
  //     "direct"
  //   );
  // };

  const handleBuyNow = (e) => {
    e.stopPropagation();

    const hasMultipleVariants = product?.variants?.length > 1;

    const hasMultipleSizes = product?.variants?.some(
      (v) => v.sizes?.length > 1
    );

    // 🚦 If user must choose options → go to PDP
    if (hasMultipleVariants || hasMultipleSizes) {
      navigate(`/view-one-product/${product._id}`);
      return;
    }

    // ✅ Safe to direct checkout (single variant & size)
    const variant = product.variants?.[0];
    const size = variant?.sizes?.[0];

    if (!variant || !size) {
      toast.error("Product not available");
      return;
    }

    const rawItem = {
      product: {
        _id: product._id,
        name: product.productName,
      },
      variant: {
        _id: variant._id,
        colorCode: variant.colorCode,
        images: variant.images,
      },
      size: {
        _id: size._id,
        size: size.size || "",
        price: size.price,
        mrp: size.mrp,
        stock: size.stock,
      },
      quantity: 1,
    };

    const normalizedItem = normalizeCartItem(rawItem);

    navigateToCheckout(
      navigate,
      [normalizedItem],
      "direct"
    );
  };


  return (
    <div
      onClick={() => navigate(`/view-one-product/${product._id}`)}
      className="
        bg-white rounded-xl border
        hover:shadow-lg transition
        cursor-pointer flex flex-col
      "
    >
      {/* IMAGE */}
      <div className="aspect-[4/3] bg-gray-100 rounded-t-xl overflow-hidden">
        <img
          src={product.previewImage || "https://via.placeholder.com/300"}
          alt={product.productName}
          className="w-full h-full object-contain transition-transform hover:scale-105"
        />
      </div>

      {/* CONTENT */}
      <div className="p-3 flex flex-col flex-1">
        {/* BRAND */}
        <p className="text-xs font-semibold uppercase text-gray-700">
          {product.brand}
        </p>

        {/* NAME */}
        <p className="text-sm text-gray-600 line-clamp-2 mt-1 flex-1">
          {product.productName}
        </p>

        {/* PRICE */}
        {priceInfo && (
          <div className="mt-2 flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-sm">
              {priceInfo.minPrice === priceInfo.maxPrice
                ? `₹${priceInfo.minPrice}`
                : `₹${priceInfo.minPrice} – ₹${priceInfo.maxPrice}`}
            </span>

            {priceInfo.maxMRP && (
              <span className="line-through text-gray-400 text-xs">
                ₹{priceInfo.maxMRP}
              </span>
            )}

            {priceInfo.discount && (
              <span className="text-green-600 text-xs font-medium">
                {priceInfo.discount}% OFF
              </span>
            )}
          </div>
        )}

        {/* ACTIONS */}
        <div className="mt-3 flex gap-2">
          {/* BUY NOW */}
          <button
            onClick={handleBuyNow}
            className="
              flex items-center justify-center gap-1
              bg-[#007BFF] hover:bg-blue-700
              text-white text-sm font-medium
              px-3 py-2 rounded-lg w-full
              transition
            "
          >
            {/* <Zap size={16} /> */}
            Buy Now
          </button>

          {/* ADD TO CART */}
          <button
            onClick={handleAddToCart}
            className="
              border border-[#007BFF]
              text-[#007BFF] hover:bg-blue-50
              px-3 py-2 rounded-lg
              transition flex items-center justify-center
            "
          >
            <ShoppingCart size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
